import React from 'react'

import {
  Box,
  Container,
  Grid,
} from '@mui/material'

const LoadingPage = () => {
  return (
    <Container maxWidth='sm'>
      <Grid container sx={{ minHeight: '100vh' }} align='center' alignItems='center'>
        <Grid item xs={12}>
          <Box
            component='img'
            src='/assets/images/logo.gif'
            sx={{ width: '30%' }}
          />
        </Grid>
      </Grid>
    </Container>
  )
}

export default LoadingPage